export default [
  'akna',
  'akna-alsó',
  'akna-felső',
  'alagút',
  'alsórakpart',
  'arborétum',
  'autóút',
  'állat és növ.kert',
  'állomás',
  'árnyék',
  'árok',
  'átjáró',
  'barakképület',
  'barlang',
  'bejáró',
  'bekötőút',
  'bánya',
  'bányatelep',
  'bástya',
  'bástyája',
  'csárda',
  'csónakházak',
  'domb',
  'dűlő',
  'dűlők',
  'dűlősor',
  'dűlőterület',
  'dűlőút',
  'egyetemváros',
  'egyéb',
  'elágazás',
  'emlékút',
  'erdészház',
  'erdészlak',
  'erdő',
  'erdősor',
  'fasor',
  'fasora',
  'felső',
  'forduló',
  'főmérnökség',
  'főtér',
  'főút',
  'föld',
  'gyár',
  'gyártelep',
  'gyárváros',
  'gyümölcsös',
  'gát',
  'gátsor',
  'gátőrház',
  'határsor',
  'határút',
  'hegy',
  'hegyhát',
  'hegyhát dűlő',
  'hegyhát',
  'köz',
  'hrsz',
  'hrsz.',
  'ház',
  'hídfő',
  'iskola',
  'játszótér',
  'kapu',
  'kastély',
  'kert',
  'kertsor',
  'kerület',
  'kilátó',
  'kioszk',
  'kocsiszín',
  'kolónia',
  'korzó',
  'kultúrpark',
  'kunyhó',
  'kör',
  'körtér',
  'körvasútsor',
  'körzet',
  'körönd',
  'körút',
  'köz',
  'kút',
  'kültelek',
  'lakóház',
  'lakókert',
  'lakónegyed',
  'lakópark',
  'lakótelep',
  'lejtő',
  'lejáró',
  'liget',
  'lépcső',
  'major',
  'malom',
  'menedékház',
  'munkásszálló',
  'mélyút',
  'műút',
  'oldal',
  'orom',
  'őrház',
  'őrházak',
  'őrházlak',
  'park',
  'parkja',
  'parkoló',
  'part',
  'pavilon',
  'piac',
  'pihenő',
  'pince',
  'pincesor',
  'postafiók',
  'puszta',
  'pálya',
  'pályaudvar',
  'rakpart',
  'repülőtér',
  'rész',
  'rét',
  'sarok',
  'sor',
  'sora',
  'sportpálya',
  'sporttelep',
  'stadion',
  'strandfürdő',
  'sugárút',
  'szer',
  'sziget',
  'szivattyútelep',
  'szállás',
  'szállások',
  'szél',
  'szőlő',
  'szőlőhegy',
  'szőlők',
  'sánc',
  'sávház',
  'sétány',
  'tag',
  'tanya',
  'tanyák',
  'telep',
  'temető',
  'tere',
  'tető',
  'turistaház',
  'téli kikötő',
  'tér',
  'tömb',
  'udvar',
  'utak',
  'utca',
  'utcája',
  'út',
  'útja',
  'útőrház',
  'üdülő',
  'üdülő-part',
  'üdülő-sor',
  'üdülő-telep',
  'vadaskert',
  'vadászház',
  'vasúti megálló',
  'vasúti őrház',
  'vasútsor',
  'vasútállomás',
  'vezetőút',
  'villasor',
  'vágóhíd',
  'vár',
  'várköz',
  'város',
  'vízmű',
  'völgy',
  'zsilip',
  'zug',
];
